import "./contact.css"

import image1 from "../../assets/Images/Contact/Hero-Section.jpg"
import { HelmetProvider } from 'react-helmet-async';
import instagram from "../../assets/Images/Elements/Instagram.svg"
import LinkedIn from "../../assets/Images/Elements/LinkedIn.svg"

import Header from "../../assets/components/01_header/header"
import Footer from "../../assets/components/02_footer/footer"

import ContactComponent from "../../assets/components/08_contact_component/08_contact_component"

export default function Contact() {
    return (
        <div>
            <HelmetProvider>
                <title>Connect With Top Digital Experts in Mumbai</title>
                <meta name="Get in touch with Adstrate, a digital marketing agency in Mumbai specializing in social media marketing in Mumbai, Instagram marketing agency services, and content creation." />
                <link rel="canonical" href="https://adstrate.in/contact" />
            </HelmetProvider>
            <Header />
            <img src={image1} alt="One person giving photo to another"  className="Contact-HeroImage"/>
            <ContactComponent />
            <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13000.28095638266!2d72.72651894249826!3d19.198161882031737!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x623604f5bbc025ab%3A0x5c72143a871cd4e9!2sAdstrate!5e0!3m2!1sen!2sin!4v1772439806177!5m2!1sen!2sin"
            allowfullscreen="" 
            loading="lazy" 
            referrerpolicy="no-referrer-when-downgrade"
            className="Contact-Map"
            ></iframe>
            <Footer />
        </div>
    );
}